export default __webpack_public_path__ + "static/aerial_hero@2x-3d6473c1c50e48ba311d791536afdfa7.jpg";